import dayjs from 'dayjs'

import { locales } from '@web/shared/constants/locales.constant'


export const formatDate = (
  date?: string | Date,
  format: string = locales.ru.dateFormat
) => (date ? dayjs(date).format(format) : '')
